import { BaseTextMergeContainerEditor } from "./BaseTextMergeContainerEditor";
import React from "react";
import { TextEditorRegistration } from "../../Utilities/RegisterTextEditor";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import FormatIndentIncreaseIcon from "@mui/icons-material/FormatIndentIncrease";
import { BlockQuoteElement } from "../../../rule-engine-core/TextMerge/Elements/Text/BlockQuoteElement";
import { TextMergeEditContext } from "../../../rule-engine-core/TextMerge/TextMergeEditContext";

export class TextMergeBlockQuoteEditor extends BaseTextMergeContainerEditor<BlockQuoteElement> {
    renderContent(editContext: TextMergeEditContext, styles: object): React.ReactNode {
        return (
            <p>
                <blockquote style={styles}>
                    {this.editorData?.elements.map((e) => {
                        let editor = TextEditorRegistration.getExpressionByTypeName(e.__type)?.create(e);
                        return (
                            <ObserveState
                                listenTo={e}
                                control={() => {
                                    return editor?.renderDisplay(e, editContext);
                                }}
                            />
                        );
                    })}
                </blockquote>
            </p>
        );
    }

    getIcon(): JSX.Element {
        return <FormatIndentIncreaseIcon />;
    }
}
